// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"SectionWrapper_sectionWrapper__DVkDr","title":"SectionWrapper_title__KL9h2","backgroundWrapper":"SectionWrapper_backgroundWrapper__rMqRX"};